"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;

var _stylitas = require("@creditas/stylitas");

var _styleUtilities = require("@creditas-lab/style-utilities");

var _utils = require("../../utils");

var Wrapper = _stylitas.styled.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: block;\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: ", ";\n  letter-spacing: ", "px;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: underline;\n  }\n\n  ", "\n"])), _utils.componentToken.footer.main.links.color, _utils.componentToken.footer.fontFamily, _utils.componentToken.footer.main.baseText.xs.fontSize, _utils.componentToken.footer.main.links.fontWeight, _utils.componentToken.footer.main.baseText.xs.lineHeight, _utils.componentToken.footer.main.baseText.xs.letterSpacing, _styleUtilities.media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    font-size: ", ";\n    line-height: ", ";\n  "])), _utils.componentToken.footer.main.baseText.md.fontSize, _utils.componentToken.footer.main.baseText.md.lineHeight));

exports.Wrapper = Wrapper;